module.exports = __webpack_public_path__ + "static/media/payment.a0d837c1.png";